import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
const inclusions = ['6 Tomos Profesionales', '5 Bonos Exclusivos', 'Acceso inmediato'];
const checkoutUrl = 'https://metodo-reconstruccion-interior.impultienda.ar/checkout';
export function PricingCards() {
  return <section id="oferta" className="scroll-mt-4 bg-ink px-4 py-20 text-white md:py-28" data-id="element-161" data-mp="2bdtyh0355ysr">
      <div className="mx-auto max-w-5xl" data-id="element-162" data-mp="2fenmdtgl3dln">
        <div className="mx-auto max-w-2xl text-center" data-id="element-163" data-mp="2fdkv3kfcn957">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-rose" data-id="element-164" data-mp="2k5vxqv1h591g">Tu recorrido empieza hoy</p>
          <h2 className="mt-3 font-heading text-4xl font-semibold leading-tight md:text-5xl" data-id="element-165" data-mp="2p58gb3lbbty8">
            Método Reconstrucción Interior
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} className="mx-auto mt-12 max-w-md rounded-2xl border border-rose/45 bg-white p-7 text-ink shadow-2xl shadow-black/20 md:p-9" data-id="element-166" data-mp="2u1ywdqx4apjn">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-clay-dark" data-id="element-167" data-mp="3ok60kj3me6ko">Incluye</p>
          <ul className="mt-6 space-y-4" data-id="element-168" data-mp="3jkjowe3fwydz">
            {inclusions.map(item => <li key={item} className="flex items-center gap-3 text-base font-semibold" data-id="element-169" data-mp="3fiy7cffynvxg">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-rose text-clay-dark" data-id="element-170" data-mp="g18a0q957551">
                  <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-171" data-mp="b4zyrny2fw35" />
                </span>
                {item}
              </li>)}
          </ul>

          <div className="mt-9 border-t border-clay/15 pt-7" data-id="element-172" data-mp="29tpgezl6vvv">
            <p className="font-heading text-5xl font-semibold tracking-tight text-ink" data-id="element-173" data-mp="ys98ld6coyo2">$21.990</p>
            <p className="mt-1 text-sm font-bold uppercase tracking-[0.14em] text-ink/55" data-id="element-174" data-mp="u214xc3cw28o">ARS</p>
          </div>

          <a href={checkoutUrl} onClick={() => trackInitiateCheckout('Método Reconstrucción Interior', 21990)} className="mt-8 flex w-full items-center justify-center rounded-full bg-clay px-6 py-4 text-sm font-bold uppercase tracking-[0.06em] text-white transition-colors hover:bg-clay-dark" data-id="element-175" data-mp="2o93fnbq02akr">
            Quiero comenzar ahora
          </a>
          <div className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-ink/55" data-id="element-176" data-mp="25jezioqt4ypg">
            <span className="inline-flex items-center gap-1.5" data-id="element-177" data-mp="2aii1u1fekqtq"><ZapIcon className="h-3.5 w-3.5 text-clay-dark" aria-hidden="true" data-id="element-178" data-mp="2ag5cv4b89g76" />Acceso inmediato</span>
            <span className="inline-flex items-center gap-1.5" data-id="element-179" data-mp="1vnbw7fk7yu0x"><ShieldCheckIcon className="h-3.5 w-3.5 text-clay-dark" aria-hidden="true" data-id="element-180" data-mp="20l3mk557u830" />Garantía de 7 días</span>
          </div>
        </motion.div>
      </div>
    </section>;
}